// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table {
  overflow-y: scroll !important;
  padding-top: 3px;
}

.search {
  height: auto;
  min-width: -moz-fit-content;
  min-width: fit-content;
}

.table-items {
  padding-bottom: 40px;
}

.view-link {
  vertical-align: middle;
}

.table-header {
  border-top: none;
  position: sticky;
  top: 0;
  background: #F3F3F3;
  z-index: 1;
  vertical-align: middle !important;
}

.link-text {
  font-family: Inter;
  font-style: normal;
  font-weight: bold;
  line-height: 12px;
  letter-spacing: 0.254903px;
  color: var(--theme-main-color, #055C8D);
  cursor: pointer;
  font-size: 10px;
  position: relative;
  bottom: 7px;
}

.cursor-pointer {
  cursor: pointer;
}

.link-text .map-link-text {
  padding: 0 5px 0 2px;
}

.secondary {
  margin-left: 5px;
}

.view-link-content {
  align-items: center !important;
}
.view-link-content:focus {
  outline: none !important;
}

.view-link-content .map-link {
  left: 20px;
}

*:focus {
  outline: none !important;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
